import { Accordion } from '@chakra-ui/accordion'
import { HStack, Link } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import {
  DocumentationIntegrationBasics,
  DocumentationImageTransformation,
  DocumentationAPIandSDKs,
} from '../../components/Support'
import { MainContentHeadingBox } from '../Base/MainContent'
import { UserContext } from '../../providers'

const DocumentationLayout = (): React.ReactElement => {
  const { t } = useTranslation()
  const { user } = useContext(UserContext)

  return (
    <>
      <MainContentHeadingBox justifyContent="right">
        <HStack w="full" justifyContent="flex-end" spacing={4}>
          <Link isExternal href="https://docs.imagekit.io/">
            {t('imagekit_docs')}
          </Link>
          <Link isExternal href="https://statuspage.imagekit.io/">
            {t('service_status')}
          </Link>
          {user?.pricingPlan.isPaidPlan ? (
            <Link
              onClick={() => {
                window.Intercom('show')
              }}
              _hover={{ textDecoration: 'none', outline: 'none' }}
              borderColor="appClearBlue"
              borderRadius="lg"
              border="solid"
              p={2}
            >
              {t('support_ticket')}
            </Link>
          ) : null}
        </HStack>
      </MainContentHeadingBox>
      <Accordion borderColor="#9ea3ad33" allowToggle>
        <DocumentationIntegrationBasics />
        <DocumentationImageTransformation />
        <DocumentationAPIandSDKs />
      </Accordion>
    </>
  )
}

export default DocumentationLayout
